import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent implements OnInit {
  username: string = '';
  maskedEmail: string = '';
  loading: boolean = false;
  emailSent: boolean = false;
  error: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    // Get username from query params
    this.route.queryParams.subscribe(params => {
      this.username = params['username'] || '';
      
      if (this.username) {
        // Fetch masked email on page load
        this.userService.getMaskedEmail(this.username).subscribe({
          next: (response) => {
            this.maskedEmail = response.maskedEmail;
          },
          error: (err) => {
            console.error('Error fetching masked email:', err);
            this.error = 'Unable to retrieve email information.';
          }
        });
      }
    });
  }

  sendResetLink(): void {
    this.loading = true;
    this.error = null;

    this.userService.sendPasswordResetEmail(this.username).subscribe({
      next: (response) => {
        this.loading = false;
        this.emailSent = true;
        // Backend returns masked email in response
        if (response.maskedEmail) {
          this.maskedEmail = response.maskedEmail;
        }
      },
      error: (err) => {
        this.loading = false;
        console.error('Error sending reset email:', err);
        //always show success even on error
        this.emailSent = true;
        // Keep the existing maskedEmail that was fetched on page load
      }
    });
  }

  backToLogin(): void {
    this.router.navigate(['/login']);
  }
}
